import {
  BUTTON_TYPES,
  EVENT_NAMES,
  MENU_TYPES,
  SCREEN_NAMES,
} from '/enum/tealium.enum';
import {getAnalyticsUtilDefaultInstance} from '/util/analytics/analytics.util';
import {clearScreenParams} from '/util/async-storage';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

/**
 * Generates a callback to be called when tab is pressed, sends tealium tracking and updated currentScreen in redux
 *
 * @param {object} params - Parameters
 * @param {string} params.tabName - the name of the current tab to be tracked in redux
 * @param {string} params.buttonName - the text of the tab button
 *
 * @returns {function} - Callback - A function to be called when tab is pressed
 */
export function generateOnTabPress({tabName, buttonName, lastPaidRank}: any) {
  return ({currentScreen}: any) =>
    () => {
      // Track navigational click
      const trackNavigationalClick = (targetName: any) => {
        getAnalyticsUtilDefaultInstance().trackNavigationalClick({
          menuName: 'tab',
          targetName,
        });
      };

      const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
        eventName: EVENT_NAMES.navigationClick,
      });

      trackNavigationalClick(tabName);

      sendEvent({
        menuType: MENU_TYPES.tabs,
        buttonName: buttonName,
        buttonType: BUTTON_TYPES.text,
        screenName: currentScreen,
        lastPaidRank: lastPaidRank,
      });

      // Clear report persistence when switching tabs
      if (tabName === 'teams' || tabName === 'watchlist') {
        clearScreenParams(SCREEN_NAMES.myTeamsReport);
      }
    };
}
